import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse } from '@fortawesome/pro-solid-svg-icons/faHouse';
import { faBuilding } from '@fortawesome/pro-solid-svg-icons/faBuilding';

import { Button } from 'ui-components/components/button';
import { noop } from 'ui-components/default-props/noop';

import style from './validate-address-box.module.css';
import { emptyObject } from 'ui-components/default-props/empty';

const renderRecommendation = (isResidential) => {
  const icon = isResidential ? faHouse : faBuilding;
  const message = isResidential ? (
    <FormattedMessage defaultMessage='Suggested Residential Address' description='deliveryAddress.recommendedResidential' id='QlrE7X' />
  ) : (
    <FormattedMessage defaultMessage='Suggested Commercial Address' description='deliveryAddress.recommendedCommercial' id='byTwx6' />
  );
  return (
    <div className={style['address-suggestion']}>
      <FontAwesomeIcon icon={icon} />
      {message}
    </div>
  );
};

export const ValidateAddressBox = ({ validatedAddress = emptyObject, onUseValidatedAddress = noop }) => (
  <div className={style['validate-address-container']}>
    <div className={style['validated-address-picker']}>
      <div className={style['address-title']}>
        <FormattedMessage defaultMessage='Validate Address' description='deliveryAddress.validateAddressTitle' id='D4lE4y' />
      </div>
      {renderRecommendation(validatedAddress.isResidential)}
      <div className={style['selected-address']}>
        <div>{validatedAddress.name}</div>
        {validatedAddress.company && <div>{validatedAddress.company}</div>}
        <div>{validatedAddress.line1}</div>
        <div>{validatedAddress.line2}</div>
        <div>{`${validatedAddress.city}, ${validatedAddress.state} ${validatedAddress.postalCode} ${validatedAddress.countryCode}`}</div>
      </div>
      <Button className={style['use-address-button']} onClick={onUseValidatedAddress} theme='link'>
        <FormattedMessage defaultMessage='Use this Address' description='deliveryAddress.useThisAddress' id='AKxnEI' />
      </Button>
    </div>
  </div>
);

ValidateAddressBox.propTypes = {
  onUseValidatedAddress: PropTypes.func,
  validatedAddress: PropTypes.object,
};
